import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { withTheme } from '../core/theming';
import { PropTypesRepo } from '../functions/_propTypes';

import Div from './Div';

/* eslint-disable indent */

const takeReqWidth = (i, colCount) => {
  const flexAuto = 'flex-basis: 0; flex-grow: 1; max-width: 100%;';
  return css`
    ${(typeof parseInt(i, 10) === 'number' || i.xs) &&
    (i.xs !== undefined || i.xs !== 'auto'
      ? `flex: 0 1 ${(100 * (parseInt(i.xs, 10) || parseInt(i, 10))) / colCount}%;
            max-width: ${(100 * (parseInt(i.xs, 10) || parseInt(i, 10))) / colCount}%`
      : flexAuto)};
    ${i.sm &&
    `@media (min-width: 576px) {
        ${
          i.sm !== 'auto'
            ? `max-width: ${(100 * parseInt(i.sm, 10)) / colCount}%;
              flex: 0 0 ${(100 * parseInt(i.sm, 10)) / colCount}%;`
            : flexAuto
        }
      }`}
    ${i.md &&
    `@media (min-width: 768px) {
        ${
          i.md !== 'auto'
            ? `max-width: ${(100 * parseInt(i.md, 10)) / colCount}%;
            flex: 0 0 ${(100 * parseInt(i.md, 10)) / colCount}%;`
            : flexAuto
        }     
      }`}
    ${i.lg &&
    `@media (min-width: 992px) {
        ${
          i.lg !== 'auto'
            ? `max-width: ${(100 * parseInt(i.lg, 10)) / colCount}%;
            flex: 0 0 ${(100 * parseInt(i.lg, 10)) / colCount}%;`
            : flexAuto
        }  
      }`}
    ${i.xl &&
    `@media (min-width: 1200px) {
        ${
          i.xl !== 'auto'
            ? `max-width: ${(100 * parseInt(i.xl, 10)) / colCount}%;
            flex: 0 0 ${(100 * parseInt(i.xl, 10)) / colCount}%;`
            : flexAuto
        }
      }`}
  `;
};

const takeReqOffset = (i, colCount) => css`
  ${(typeof parseInt(i, 10) === 'number' || i.xs) && `margin-left: ${(100 * (parseInt(i.xs, 10) || i)) / colCount}%;`}
  ${i.sm != null &&
  `@media (min-width: 576px) {
      margin-left: ${(100 * parseInt(i.sm, 10)) / colCount}%;
    }`}
  ${i.md != null &&
  `@media (min-width: 768px) {
      margin-left: ${(100 * parseInt(i.md, 10)) / colCount}%;
    }`}
  ${i.lg != null &&
  `@media (min-width: 992px) {
      margin-left: ${(100 * parseInt(i.lg, 10)) / colCount}%;
    }`}
  ${i.xl != null &&
  `@media (min-width: 1200px) {
      margin-left: ${(100 * parseInt(i.xl, 10)) / colCount}%;
    }`}
`;

/* eslint-enable indent */
/* eslint-disable react/prop-types */

const BaseColumn = ({ p, m, theme, size, gutterWidth, ...rest }) => (
  <Div p={{ y: '0', x: `calc(${gutterWidth || theme.grid.gutterWidth}/2)` }} {...rest} />
);

/* eslint-enable react/prop-types */

const ColStyled = styled(BaseColumn)`
  ${(props) => takeReqWidth(props.size, props.theme.grid.colCount)};
  ${(props) => props.offset && takeReqOffset(props.offset, props.theme.grid.colCount)};
`;

const Col = (props) => <ColStyled {...props} />;

/* eslint-disable react/require-default-props */

Col.propTypes = {
  size: PropTypesRepo.size,
  offset: PropTypesRepo.offset,
  gutterWidth: PropTypes.number,
};

Col.defaultProps = {
  size: 'auto',
  offset: 0,
  gutterWidth: 0,
};

/* eslint-enable react/require-default-props */

export default withTheme(Col);
